import React, { createContext, useState, useEffect, useContext } from "react";
import {
  setItemWithExpiry,
  getItemWithExpiry,
} from "../utils/localStorageUtils";
import { forceLogout } from "../utils/authUtils";

export const LocalStorageContext = createContext();
const key = "user-info";

export const LocalProvider = ({ children }) => {
  const [data, setData] = useState(getItemWithExpiry(key));

  useEffect(() => {
    const storedData = getItemWithExpiry(key);

    if (storedData) {
      setData(storedData);
      // navigate("/rptpl")
    } else {
      setData(null);
    }
  }, []);

  // Periodic check for token expiry with auto-logout
  useEffect(() => {
    const checkTokenExpiry = () => {
      const storedData = getItemWithExpiry(key);
      if (!storedData && data) {
        // Token has expired, force logout
        forceLogout();
      }
    };

    // Check every 30 seconds
    const interval = setInterval(checkTokenExpiry, 30000);

    return () => clearInterval(interval);
  }, [data]);

  const saveData = (value, delay) => {
    setItemWithExpiry(key, value, delay);
    setData(value);
  };

  const removeData = () => {
    localStorage.removeItem(key);
    setData(null);
  };

  const logout = () => {
    removeData();
    forceLogout();
  };

  return (
    <LocalStorageContext.Provider value={{ data, saveData, removeData, logout }}>
      {children}
    </LocalStorageContext.Provider>
  );
};

export const useLocalStorageContext = () => {
  return useContext(LocalStorageContext);
};
